import { render, staticRenderFns } from "./customerLvyueTongji2024.vue?vue&type=template&id=3632f124"
import script from "./customerLvyueTongji2024.vue?vue&type=script&lang=js"
export * from "./customerLvyueTongji2024.vue?vue&type=script&lang=js"
import style0 from "./customerLvyueTongji2024.vue?vue&type=style&index=0&id=3632f124&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports